var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VForm',{attrs:{"form":_vm.form},on:{"submit":_vm.onSubmit}},[_c('VMulticheckbox',{attrs:{"name":"text_to_be_confirmed","hint":_vm.$t('substore.text_to_be_confirmed_hint'),"required":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }